module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This is a Perceptive Images 2015 © publication exclusively for Pen & Sword Books Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Additional editorial material and specific images were supplied by my good friends David Anderson and John Chalcraft, whose encouragement and shared railway knowledge was invaluable. The additional inclusion of images from the collections of a great many accomplished photographers, past and present, help to tell the ‘Castle’ class story. The publication of those images serves as a lasting tribute to their skills.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Keith Langston 2015")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Photographic libraries whose images have been used include Author, Mike Bentley Collection, Dave Cobbe-C.R.L Coles Collection, Cresselley Photos, John Day Collection, Blenheim Duxford Limited, Bomber Command, Gordon Edgar Collection, Great Western Society, Ray Hinton Collection, J&J Collection, Mike Morant Collection, Norman Preedy Collection, Rail Photoprints Collection, R.C. Riley Collection, Royal Air Force, Royal Australian Air Force, Alan Sainty Collection, Transport Treasury and the Roy Vincent Collection.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Individual photographers whose images have been used include, Author, David Anderson, A.E. Bennett, Hugh Ballantyne, Jim Carter, John Chalcraft, J.J. Cunningham, A.E. Durrant, Clive Hanley, Willy Hermiston, Tony Hisgett, Martyn Hunt, Fred Kerr, Phil Neale, L. Nicholson, Adrian Pingstone, Malcolm Ranieri, S. Rickard, Brian Robbins, Pete Sherwood, Ian Turnbull, R.S. Wilkins, Brian Wilson, Mathew Wilson, R.A. Whitfield and Phil Vabre.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Further Research")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Over many years the popular Collett ‘Castle’ class locomotives have featured in books and magazine articles, and now in the 21st century information is additionally available via the World Wide Web. Further research about the class can be undertaken by consulting these titles, and indeed others:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("‘Castles’ and ‘Kings’ at Work")]), _vm._v(" – Michael Rutherford; Ian Allan Publishing 1982")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Portraits of ‘Castles’")]), _vm._v(" – Bryan Holden and Kenneth Leech; Moorland 1981")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("The Power of the ‘Castles’")]), _vm._v(" – R.C Riley & Peter Walker; Oxford Publishing Co 2003")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("British Steam – ‘Castles & Kings’")]), _vm._v(" – Keith Langston; Morton’s Media 2010")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Amongst the many websites available with ‘Castle’ class content are:")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('i', [_vm._v("The Great Western Society")]), _vm._v(" – ")]), _c('a', {
    attrs: {
      "href": "http://www.gwsmainline.org/",
      "target": "_blank"
    }
  }, [_vm._v("www.gwsmainline.org/")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Tyseley Locomotive Works")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "http://www.tyseleylocoworks.co.uk/tlw/",
      "target": "_blank"
    }
  }, [_vm._v("www.tyseleylocoworks.co.uk/tlw/")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Steam-Museum of the Great Western Railway")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "http://www.steam-museum.org.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.steam-museum.org.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Rail Info UK")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "http://www.railuk.info/steam/",
      "target": "_blank"
    }
  }, [_vm._v("www.railuk.info/steam/")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("BRDatabase")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "http://www.brdatabase.info/",
      "target": "_blank"
    }
  }, [_vm._v("www.brdatabase.info/")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a290636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 66
// module chunks = 0